// https://stackoverflow.com/questions/38473207/how-can-i-using-select2-with-webpack
// https://stackoverflow.com/a/49722514
// https://github.com/select2/select2/issues/6146#issuecomment-1066034570
import $ from "jquery";
import select2 from "select2";
import { setDropdownPositionOptions } from "./select2Overrides";
import { SCREEN_WIDTHS } from "components/utility/constants/screen_widths";

export const forms = () => {
	// Capturing all the types of text input fields in the form; ignore checkbox and radio
	select2(window, $);
	const formAllFields = $(
		'.scf-form input[type="text"], .scf-form input[type="email"], .scf-form input[type="tel"], .scf-form textarea, .scf-form select'
	);

	// Initialize select2 dropdownPosition preference
	setDropdownPositionOptions($);

	function blurInput(el) {
		const parentContainer = $(el).parent();
		const inputMarginTop = parseInt($(el).css("margin-top"), 10);
		const fieldValueLength = el.value.length;
		if (fieldValueLength <= 0) {
			parentContainer
				.find("label")
				.animate({ top: inputMarginTop + "px", "font-size": "1rem" }, 200);
		}

		if ($(el).attr("data-val-required")) {
			// Allow SiteCore to handle the error label by hiding ours
			if (parentContainer.find("span.field-validation-error").length) {
				parentContainer.find("label").hide();
				parentContainer.addClass("form-field-error");
			}
			if (parentContainer.find("span.field-validation-valid").length) {
				parentContainer.find("label").show();
				parentContainer.removeClass("form-field-error");
			}
		}
		parentContainer.removeClass("currentactive");
	}

	async function setInputContainerHeight(inputEl) {
		return new Promise((resolve) => {
			if ($(inputEl).prop("tagName") !== "TEXTAREA") {
				const parentContainer = $(inputEl).parent();
				const inputHt = $(inputEl).height();
				const labelHt = parentContainer.find("label").height();
				parentContainer.css("height", inputHt + labelHt);
			}
			resolve();
		});
	}

	async function moveLabel(elements) {
		return new Promise((resolve) => {
			$(elements).each(function () {
				const inputMarginTop = parseInt($(this).css("margin-top"), 10);
				const animateOptions = {
					duration: 200,
					progress: () => setInputContainerHeight(this),
					complete: () => resolve()
				};
				const parentContainer = $(this).parent();
				const label = $(this).parent().find("label");

				if ($(this).val() !== null) {
					if ($(this).val().length === 0) {
						if (parentContainer.find("span.field-validation-valid").length) {
							label.animate(
								{
									top: inputMarginTop + "px",
									"font-size": "1rem"
								},
								animateOptions
							);
						} else {
							label.animate(
								{
									top: "0px",
									"font-size": "0.75rem"
								},
								animateOptions
							);
						}
					} else {
						label.animate(
							{
								top: "0px",
								"font-size": "0.75rem"
							},
							animateOptions
						);
					}
					label.css("position", "absolute");
				}
			});
		});
	}

	function setTextAreaSize() {
		return new Promise((resolve) => {
			// Auto-size textareas to fit; creating a hidden clone div in order to measure it as it grows and apply it to existing textareas
			var initLabelTopPosition = 24; // FIXME: see if this value can be calculated from input container amd remove this
			var scfTxts = document.querySelectorAll(".scf-form textarea");
			for (var el of scfTxts) {
				el.classList.add("txta");
			}
			var scfTextareas = document.querySelectorAll(".scf-form .txta");
			var scfHiddenTxtDiv = document.createElement("div");
			var scfTextContent = null;

			for (var textArea of scfTextareas) {
				textArea.classList.add("txt-area");
				// override sitecore forms authorable rows setting for Multiple-line Text component
				textArea.removeAttribute("rows");
			}

			scfHiddenTxtDiv.classList.add("hiddenTxtDiv", "txta");

			for (var textEl of scfTextareas) {
				(function (textEl) {
					// offset if label is multi-line //FIXME: adapt responsive solution as other labels, have labelHeight contribute to container height
					var labelHeightOffset = 0;
					var parentContainer = $(textEl).parent(".form-input-container");
					var labelHeight = parentContainer.find("label").outerHeight();

					if (labelHeight > 30) {
						labelHeightOffset = labelHeight - (initLabelTopPosition - 8); // subtract 8px to match other label offsets
					}

					// initialize textearea height
					var topMarginOffset = initLabelTopPosition + labelHeightOffset;
					textEl.style.height = "28px";
					textEl.style.marginTop = topMarginOffset + "px";

					// eslint-disable-next-line no-loop-func
					textEl.addEventListener("input", function () {
						textEl.parentNode.appendChild(scfHiddenTxtDiv);
						textEl.style.overflow = "hidden";
						scfTextContent = textEl.value;
						scfTextContent = scfTextContent.replace(/\n/g, "<br>");

						// This fixes the jumpy way the textarea grows if line-height isn't included
						scfHiddenTxtDiv.innerHTML = scfTextContent + '<br style="line-height: 1.5;">';

						// Briefly make the hidden div block but invisible in order to read the height
						scfHiddenTxtDiv.style.visibility = "hidden";
						scfHiddenTxtDiv.style.display = "block";
						textEl.style.height = scfHiddenTxtDiv.offsetHeight + "px";

						// Make the hidden div display:none again
						scfHiddenTxtDiv.style.visibility = "visible";
						scfHiddenTxtDiv.style.display = "none";
					});
				})(textEl);
			}
			resolve();
		});
	}

	function attachSelect2(parentEl) {
		return new Promise((resolve) => {
			$(parentEl)
				.find(".scf-form select")
				.each(function () {
					var dropdownParent = $(document.body);
					if ($(this).parents(".scf-form").length !== 0) {
						dropdownParent = $(this).parents(".scf-form");
					}
					$(this).select2({
						dropdownParent: dropdownParent,
						dropdownPosition: "below", // preferences available: 'above', 'below', 'auto'
						minimumResultsForSearch: Infinity, // removes search box in dropdown
						width: "100%"
					});

					// replace select2 dropdown indicator arrow
					var closestArrowEl = $(this).siblings(".select2").find(".select2-selection__arrow");
					if (closestArrowEl.find(".image-arrow-up").length === 0) {
						var arrowUpSvg =
							'<svg class="image-arrow-up" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">' +
							'<polygon class="image-fill-color" points="18.1,17 11.6,10.5 5.1,17.1 5.1,14.5 11.6,7.9 18.1,14.4"></polygon>' +
							"</svg>";
						closestArrowEl.find("b").hide();
						closestArrowEl.append(arrowUpSvg);
					}
				});
			resolve();
		});
	}

	function addInputContainerClasses() {
		return new Promise((resolve) => {
			formAllFields.parent().addClass("form-input-container");

			$(".scf-form [type=checkbox]").each(function () {
				$(this).parent().parent().addClass("form-input-container-checkbox");
				$(this).parent().addClass("checkbox-container");
			});
			resolve();
		});
	}

	function addAsteriskToLabels() {
		return new Promise((resolve) => {
			// Add asterisk to each "required" field label
			formAllFields.each(function () {
				if ($(this).attr("data-val-required")) {
					var currentLabel = $(this).parent().find("label");
					var currentLabelText = currentLabel.text();
					const asteriskPresentRegex = /\*$/g;
					if (!currentLabelText.match(asteriskPresentRegex)) {
						currentLabel.text(currentLabel.text() + " *");
					}
				}
			});

			$(".form-input-container-checkbox").each(function () {
				const checkboxLabel = $(this)[0].querySelector(".checkbox-container");
				if ($(this).find("input[type=checkbox]")[0].hasAttribute("data-val-ischecked")) {
					if (checkboxLabel.childNodes) {
						checkboxLabel.childNodes.forEach((node) => {
							if (node.nodeType === Node.TEXT_NODE) {
								if (node.nodeValue.trim()) {
									const asteriskPresentRegex = /\*$/g;
									if (!node.nodeValue.match(asteriskPresentRegex)) {
										node.nodeValue = `${node.nodeValue.trim()}*`;
									}
								}
							}
						});
					}
				}
			});
			resolve();
		});
	}

	function addPaddingToDropdownLabels() {
		return new Promise((resolve) => {
			$(".scf-form select").each(function () {
				// Add padding to prevent label overlap of dropdown toggle arrow
				if ($(this).prop("tagName") === "SELECT") {
					$(this).parent().find("label").css("padding-right", "48px");
				}
			});
			resolve();
		});
	}

	//-- Input setup run order --//
	// 1. add container class to input element parent div
	// 2. replace necessary input elements with styleable components - select2 dropdowns
	// 3. Add asterisk to 'required' inputs
	// 4. Add right padding to dropdown labels
	// 5. Move Labels to initial postion right above input line
	// a. Check label heights and adjust height of input container to accomodate multi-line labels
	// 6. set textarea sizing

	async function setupInputs() {
		// 1.
		await addInputContainerClasses();

		// 2.
		await attachSelect2($("body"));

		// 3.
		await addAsteriskToLabels();

		// 4.
		await addPaddingToDropdownLabels();

		// 5.
		await moveLabel(
			$(
				'.scf-form input[type="text"], .scf-form input[type="email"], .scf-form input[type="tel"], .scf-form textarea, .scf-form select'
			)
		);

		// 6.
		await setTextAreaSize();
		// Auto-size textareas to fit // FIXME: will need special handling for responsiveness since these 'textareas' are set up differently
	}
	setupInputs();
	// END - Inputs setup

	// Observe inputs for errors
	var scfErrorObserver = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.attributeName === "class") {
				var mutationTarget = $(mutation.target);
				var mutationParent = mutationTarget.parent();
				var attributeValue = mutationTarget.prop(mutation.attributeName);
				if (attributeValue === "field-validation-valid") {
					mutationParent.removeClass("form-field-error");
					if (!mutationParent.hasClass("form-input-container-checkbox")) {
						mutationParent.find("label:first-of-type").show();
					}
				} else if (attributeValue === "field-validation-error") {
					mutationParent.addClass("form-field-error");
					if (!mutationParent.hasClass("form-input-container-checkbox")) {
						mutationParent.find("label:first-of-type").hide();
					}
				}
			}
		});
	});

	var scfErrorObserverConfig = {
		attributes: true,
		attributeFilter: ["class"],
		subtree: true
	};

	$(".scf-form .form-input-container, .scf-form .form-input-container-checkbox").each(function () {
		scfErrorObserver.observe(this, scfErrorObserverConfig);
	});

	// Focusing on any field changing the position and font size of the label
	formAllFields.on("focus", function () {
		var parentContainer = $(this).parent();
		parentContainer.find("label").animate({ top: "0px", "font-size": "0.75rem" }, 200);
		parentContainer.addClass("currentactive");
	});

	$(".scf-form select").on("select2:open", function () {
		var parentContainer = $(this).parent();
		parentContainer.find("label").animate({ top: "0px", "font-size": "0.75rem" }, 200);
		parentContainer.addClass("currentactive");
	});

	$(".scf-form select").on("select2:close", function (e) {
		blurInput(e.currentTarget);
	});

	// Show label when field value changes and no error state
	formAllFields.on("change input", function () {
		var parentContainer = $(this).parent();
		if (parentContainer.find("span.field-validation-error").length) {
			parentContainer.find("label").hide();
			parentContainer.addClass("form-field-error");
		}
		if (parentContainer.find("span.field-validation-valid").length) {
			parentContainer.removeClass("form-field-error");
			const videoUploadSubmitButton = $(this).find('input[type="submit"].form-with-video-upload');
			if (videoUploadSubmitButton) {
				videoUploadSubmitButton.prop("disabled", false);
			}
		}
		parentContainer.find("label").show();
	});

	// Blurring on any field changing the position and font size of the label
	formAllFields.on("blur", function () {
		blurInput(this);
	});

	formAllFields.change(function () {
		moveLabel(this);
	});

	// Custom click event for the new checkbox
	$(".scf-form [type=checkbox]").on("change", function () {
		if ($(this).parent().hasClass("checked")) {
			$(this).parent().parent().removeClass("selected");
			$(this).parent().removeClass("checked");
		} else {
			$(this).parent().parent().addClass("selected");
			$(this).parent().addClass("checked");
		}
	});

	// Reset the input size
	const formResizeObserver = new ResizeObserver((entries) => {
		entries.forEach(() => {
			$(
				'.scf-form input[type="text"], .scf-form input[type="email"], .scf-form input[type="tel"], .scf-form textarea, .scf-form select'
			).each(function () {
				setInputContainerHeight(this);
			});
		});
	});

	document.querySelectorAll(".scf-form").forEach((form) => {
		formResizeObserver.observe(form);
	});

	// Reset form on back or forward button nav
	window.addEventListener("pageshow", function () {
		$(".scf-form form").each(function () {
			$(this).trigger("reset");
		});
	});

	// Scroll to top of form on fail or success to show error or success message
	$(".scf-form form[data-ajax='true']").each(function () {
		if ($(this).parent(".scf-form").length > 0) {
			var formParentContainer = $(this).parent(".scf-form");
		} else {
			formParentContainer = $(this).parent(".scf-form-grid-right");
		}
		$(this).on("submit", function () {
			// function to apply fade in effect to message that appears after form submission
			function fadeInAfterSubmitMessage() {
				const formEl = formParentContainer.find("form[data-ajax-mode='replace-with']")[0];
				if (!formEl) {
					return false;
				}
				formEl.style.opacity = "0";
				formEl.style.transition = "opacity 500ms ease";
				requestAnimationFrame(() => {
					formEl.style.opacity = "1";
				});
				return true;
			}

			const leadType = $(this).closest(".scf-form")[0].dataset.aLeadtype;
			if (leadType) {
				const requiredFields = $(this).find("[data-val=true]");
				const validFields = $(this).find(".valid[data-val=true]");

				if (requiredFields.length === validFields.length) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: "lead_submit",
						leadType: leadType
					});
				}
			}

			// Disables submit button after form submission to prevent multiple submissions
			const videoUploadSubmitButton = $(this).find('input[type="submit"].form-with-video-upload');
			if (videoUploadSubmitButton.length) {
				const requiredFields = $(this).find("[data-val=true]");
				const validFields = $(this).find(".valid[data-val=true]");

				if (videoUploadSubmitButton.length && requiredFields.length === validFields.length) {
					videoUploadSubmitButton.prop("disabled", true);
					$(this).one(
						"ajax:failure",
						videoUploadSubmitButton.prop.bind(videoUploadSubmitButton, "disabled", false)
					);
				}
			}

			const parentContainer = formParentContainer.parent();
			const isInTile = parentContainer.hasClass("dTileContent");
			// if the form is in a tile and the form is submitted with no validation errors,
			// observe the form for changes and apply fade in effect to the message that appears after submission
			if (isInTile) {
				if (!fadeInAfterSubmitMessage()) {
					const tileObserver = new MutationObserver(() => {
						if (fadeInAfterSubmitMessage()) {
							tileObserver.disconnect();
						}
					});
					tileObserver.observe(formParentContainer[0], { childList: true, subtree: true });
				}
			}
			const isMobile = () => window.matchMedia(`(max-width: ${SCREEN_WIDTHS.SM}px)`).matches;
			// if the form is NOT in a tile or if form is in a tile at mobile only
			// scroll to the top of the form or top of tile if form is in tile at mobile
			if (!isInTile || isMobile()) {
				// grabbing offset values here since they change upon page load
				var parentOffsetTop = isInTile
					? parseInt($(formParentContainer).parent().parent().offset().top)
					: parseInt($(formParentContainer).offset().top);
				var headerHeight = $("[data-view='public-nav']").length
					? parseInt($("[data-view='public-nav']").css("height"), 10)
					: parseInt($("#global-header").css("height"), 10);
				var scrollTopVal =
					(parentOffsetTop < headerHeight ? headerHeight : parentOffsetTop - headerHeight) + "px";
				var scrollToFormTop =
					"$('body,html').animate({ scrollTop: '" + scrollTopVal + "' }, 500 );";
				// add the scrollToFormTop function to the success and failure functions
				$(this).attr({
					"data-ajax-success": scrollToFormTop + $(this).attr("data-ajax-success"),
					"data-ajax-failure": scrollToFormTop + $(this).attr("data-ajax-failure")
				});
			}
		});
	});
};
